module.exports = __webpack_public_path__ + "img/blast.b0f88dea.png";